/* eslint-disable @typescript-eslint/no-explicit-any */
export function FormToObject<T>(Form : FormData, object : any){
    for (const [key, value] of Form.entries()) {
      try {
        if (key as keyof T) {
          object[key as keyof T] = value as any;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("Erro ao converter formulário para o item - ", key)
      }
    }
    return object as T;
}


// export function ObjectToFormData<T>(object: T): FormData {
//   const formData = new FormData();

//   for (const key in object) {
//       if (Object.prototype.hasOwnProperty.call(object, key)) {
//           const value = object[key as keyof T];

//           // Se for um arquivo (Blob ou File), adiciona diretamente
//           if (value instanceof Blob || value instanceof File) {
//               formData.append(key, value, (value as File).name || "file");
//           } 
//           // Se for um array, adiciona cada item individualmente (ex: listas de IDs)
//           else if (Array.isArray(value)) {
//               value.forEach((item, index) => {
//                   formData.append(`${key}[${index}]`, String(item));
//               });
//           } 
//           // Se for um objeto, converte para JSON
//           else if (typeof value === "object" && value !== null) {
//               formData.append(key, JSON.stringify(value));
//           } 
//           // Caso contrário, adiciona como string
//           else {
//               formData.append(key, String(value));
//           }
//       }
//   }

//   return formData;
// }


export function AutoFormData<T extends Record<string, any>>(formElement: HTMLFormElement): FormData {
  const formData = new FormData();
  const formDataFromEvent = new FormData(formElement);

  // Itera sobre as chaves do formulário e adiciona ao FormData
  (Object.keys(formElement.elements) as Array<keyof T>).forEach((key) => {
      const value = formDataFromEvent.get(key as string);
      if (value instanceof File && value.size > 0) {
          formData.append(key as string, value, value.name);
      } else if (value !== null) {
          formData.append(key as string, value.toString());
      }
  });

  return formData;
}

export function LogFormData(formData: FormData): void {
  // eslint-disable-next-line no-console
  for (const [key, value] of formData.entries()) {
      // eslint-disable-next-line no-console
      console.log(`${key}:`, value);
  }
}